// extracted by mini-css-extract-plugin
export default {"title":"ElectronVersion_title__GYI4L","grid":"ElectronVersion_grid__u87aX","card":"ElectronVersion_card__2sa-2","link":"ElectronVersion_link__-fG6O"};